import moment from 'moment-timezone';

export const ANALYTICS_TZ = 'America/Santiago';

export function analyticsToday() {
  return moment.tz(ANALYTICS_TZ).startOf('day');
}

export function analyticsTodayDate() {
  return analyticsToday().toDate();
}

export function clampAnalyticsDate(date) {
  const today = analyticsToday();
  const value = moment(date).tz(ANALYTICS_TZ).startOf('day');
  return value.isAfter(today) ? today.clone() : value;
}

export function normalizeAnalyticsRange(startDate, endDate) {
  let start = clampAnalyticsDate(startDate);
  let end = clampAnalyticsDate(endDate);
  if (start.isAfter(end)) {
    end = start.clone();
  }
  return { startDate: start, endDate: end };
}

export function formatAnalyticsApiDate(date) {
  return moment(date).tz(ANALYTICS_TZ).format('YYYY-MM-DD');
}

export function defaultAnalyticsDateRange(days = 6) {
  const endDate = analyticsToday();
  const startDate = endDate.clone().subtract(days, 'days');
  return { startDate, endDate };
}

export function parseDatepickerChange(date) {
  return moment.tz(date, 'DD-MM-YYYY', ANALYTICS_TZ).startOf('day');
}

export function onStartDateChange(startDate, endDate) {
  return normalizeAnalyticsRange(startDate, endDate);
}

export function onEndDateChange(startDate, endDate) {
  const normalized = normalizeAnalyticsRange(startDate, endDate);
  if (normalized.endDate.isBefore(normalized.startDate)) {
    normalized.startDate = normalized.endDate.clone();
  }
  return normalized;
}
